import {
  ModuleDisplayTypeEnum,
  replacePlaceholderLabels,
  replacePlaceholderValues,
} from "@resource/common";
import {
  InfoCards,
  InterviewProcess,
  Links,
  Media,
  Mission,
  PitchPageInterviewScheduler,
  RichText,
} from "components/legacy/modules";
import _ from "lodash";
import { Theme } from "types/legacy";

type PitchPageContextData = Partial<{
  "candidate-first-name": string;
  "candidate-full-name": string;
  "company-name": string;
}> & {
  theme: Theme;
};

interface PitchPageModuleContainerProps {
  id: string;
  displayType: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  contextData?: PitchPageContextData;
  pitchPageId: string;
  isPreview?: boolean;
  showVariablesAsTokens?: boolean;
}

function PitchPageModuleContainer({
  id,
  displayType,
  pitchPageId,
  data,
  contextData,
  showVariablesAsTokens = false,
  isPreview = false,
}: PitchPageModuleContainerProps) {
  let moduleContent;
  const replacementRenderFn = showVariablesAsTokens
    ? replacePlaceholderLabels
    : replacePlaceholderValues;
  if (data.disabled) {
    return null;
  }

  switch (displayType) {
    case ModuleDisplayTypeEnum.InfoCards:
      moduleContent = <InfoCards key={id} {...data} />;
      break;

    case ModuleDisplayTypeEnum.Mission:
      moduleContent = (
        <Mission key={id} header={data.header} description={data.description} />
      );
      break;

    case ModuleDisplayTypeEnum.Links:
      moduleContent = <Links key={id} {...data} />;
      break;

    case ModuleDisplayTypeEnum.TeamPhoto:
      moduleContent = (
        <Media
          key={id}
          {...{
            ...data,
            mediaLink: data.photoUrl,
          }}
        />
      );
      break;

    case ModuleDisplayTypeEnum.Media:
      moduleContent = <Media key={id} {...data} />;
      break;

    case ModuleDisplayTypeEnum.InterviewScheduler:
      moduleContent = (
        <PitchPageInterviewScheduler
          key={id}
          pitchPageId={pitchPageId}
          greeting={data.greeting}
          slug={data.config?.slug}
          candidateName={contextData?.["candidate-full-name"]}
          disabled={isPreview}
        />
      );
      break;

    case ModuleDisplayTypeEnum.InterviewProcess:
      moduleContent = (
        <InterviewProcess
          key={id}
          stages={data.stages}
          theme={contextData?.theme}
        />
      );
      break;

    case ModuleDisplayTypeEnum.RichText:
      moduleContent = (
        <RichText
          key={id}
          header={
            contextData
              ? replacementRenderFn(
                  data.header ?? "",
                  _.omit(contextData, "theme")
                )
              : data.header
          }
          rawHtml={
            contextData
              ? replacementRenderFn(
                  data.rawHtml ?? "",
                  _.omit(contextData, "theme")
                )
              : data.rawHtml
          }
          headerTag="h3"
        />
      );
      break;

    default:
      moduleContent = <div />;
      break;
  }

  return moduleContent;
}

export default PitchPageModuleContainer;
